import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export function IconControls({
    width = '16',
    height = '16',
    className,
    ...rest
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                fillRule="evenodd"
                d="M7.813 14a2.996 2.996 0 0 1-2.821 1.992A2.996 2.996 0 0 1 2.171 14H2a1 1 0 0 1 0-2h.171a2.996 2.996 0 0 1 2.821-1.992c1.301 0 2.409.832 2.821 1.992H14a1 1 0 0 1 0 2H7.813zm-2.821-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm4.195-4.992a2.995 2.995 0 0 1 2.821-1.993A2.994 2.994 0 0 1 15 8.008a2.994 2.994 0 0 1-5.813 1H2a1 1 0 0 1 0-2h7.187zm2.813 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3.189-3a2.995 2.995 0 0 1-5.637 0H2a1 1 0 0 1 0-2h1.169a2.994 2.994 0 0 1 5.647 0H14a1 1 0 0 1 0 2H8.811zM5.992 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
            />
        </svg>
    );
}

export default IconControls;
